import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import { Apirequests } from '../../utils/ApiRequests';
import BtnSpinner from '../../components/BtnSpinner';
import { Save, X } from 'lucide-react';

function AddOrEditEvent({ event, setRefresh, close }) {

    const [formData, setFormData] = useState({
        title: '',
        language: '',
        date: '',
        time: '',
        price: '',
        image: '',
        btnShow: false,
        btnText: "",
        pageUrl: "",
        status: ""
    });

    const [isEdit, setIsEdit] = useState(false);

    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
    const [imageName, setImageName] = useState(null);
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [dragActive, setDragActive] = useState(false);
    const token = localStorage.getItem('token');

    const inputRef = useRef(null);
    const navigate = useNavigate();

    const handleDrag = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true)
        } else if (e.type === "dragleave") {
            setDragActive(false)
        }
    }, [])

    const handleDrop = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            setFormData((prevData) => ({
                ...prevData,
                backgroundImage: e.dataTransfer.files[0],
            }))
        }
    }, [])


    const handleChange = (e) => {
        const { name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];

        // Display image preview temporarily
        if (file) {

            const imageUrl = URL.createObjectURL(file);
            setImagePreviewUrl(imageUrl);

            const formData2 = new FormData();
            formData2.append('image', file);

            try {
                const response = await fetch(process.env.REACT_APP_SERVER_URI + "image/upload-image", {
                    method: "POST",
                    body: formData2
                });
                // console.log(response)
                const data = await response.json();
                if (data?.success) {
                    setFormData({
                        ...formData,
                        image: data?.data
                    });

                    // console.log(file,'file')
                    setImageName(file?.name);
                } else {
                    ErrorTost(data?.message);
                }
            } catch (error) {
                console.log(error);
                ErrorTost("Something went wrong, please try again later");
            }
        } else {
            ErrorTost("please choose a file to upload");
        }

    };

    // console.log(formData.btnShow,'btns')




    const handleCancelImage = async (e) => {
        try {
            const deleteRes = await Apirequests(`image/delete-image/${imageName}`, "DELETE", {}, {});
            // console.log(deleteRes);
            if (deleteRes?.success) {
                SuccessTost(deleteRes?.message)
                setImagePreviewUrl(null);
                setFormData({
                    ...formData,
                    image: ""
                });
                inputRef.current.value = "";
            } else {
                ErrorTost(deleteRes?.message)
            }
        } catch (error) {
            console.log(error, 'delete image frontend error')
            ErrorTost("Something went wront, please try again later.")
        }
    }

    const handleCancelDBImage = async (event) => {

        try {
            const deleteRes = await Apirequests(`image/delete-image${event?.image}`, "DELETE", {}, {});
            if (deleteRes?.success) {
                const editDBevImg = await Apirequests(`events/edit-event/${event?._id}`, 'PUT', {
                    image: "null",
                }, { Authorization: `Bearer ${token}`, });
                if (editDBevImg) {
                    setRefresh((prev) => !prev);
                } else {
                    ErrorTost(editDBevImg.message)
                }
            } else {
                ErrorTost(deleteRes?.message)
            }
        } catch (error) {
            console.log(error, 'cancel db image frontend error');
            ErrorTost("Somethingg went wrong,please try again later.")
        }
    }

    const handleAddEvent = async (e) => {
        e.preventDefault();
        // console.log(formData, 'data');
        if (!formData?.title || !formData?.language || !formData?.date || !formData?.time || !formData?.price || !formData?.image) {
            return ErrorTost("All fields required");
        }
        setLoading({ state: true, name: "addevent" });
        try {
            const postEventData = await Apirequests('events/post-event', 'POST', formData, {
                Authorization: `Bearer ${token}`,
            });
            // console.log(postEventData,'resopnse');
            if (postEventData?.success) {
                SuccessTost(postEventData?.message);
                setRefresh((prev) => !prev);
                setFormData({
                    title: '',
                    language: '',
                    date: '',
                    time: '',
                    price: '',
                    image: '',
                    btnShow: false,
                    btnText: "",
                    pageUrl: "",
                });
                setImageName(null);
                setImagePreviewUrl(null);
                close();
            } else {
                ErrorTost(postEventData?.message)
            }
        } catch (error) {
            console.log(error, 'post event error');
            ErrorTost("Something went wrong, please try again later")
        }
        setLoading({ state: false, name: "" });
    };

    const handleEditEvent = async (e) => {
        e.preventDefault();
        setLoading({ state: true, type: "editevent" });
        try {
            const editeventRes = await Apirequests(`events/edit-event/${event?._id}`, 'PUT', formData, {
                Authorization: `Bearer ${token}`,
            });
            // console.log(editeventRes, 'editEventRes');
            if (editeventRes?.success) {
                SuccessTost(editeventRes?.message);
                setRefresh((prev) => !prev);
                close();
            } else {
                ErrorTost(editeventRes?.message)
            }
        } catch (error) {
            console.log(error, 'edit event error');
            ErrorTost("Something went wrong, try again later.")
        }
        setLoading({state:false,name:""})
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // console.log(data,'data')

        if (event) {
             await handleEditEvent(e)
        } else {
            await handleAddEvent(e);
        }
    }

    useEffect(() => {
        if (event) {
            setFormData({
                title: event?.title,
                language: event?.language,
                date: event?.date,
                time: event?.time,
                price: event?.price,
                image: event?.image,
                btnShow: event?.btnShow,
                btnText: event?.btnText,
                pageUrl: event?.pageUrl,
                status: event?.status
            });
            setImagePreviewUrl(`${process.env.REACT_APP_IMAGE_URI}${event?.image}`);
            // inputRef.current.value= event?.image;
            setIsEdit(true)
        };

        return () => {
            setFormData({
                title: '',
                language: '',
                date: '',
                time: '',
                price: '',
                image: '',
                btnShow: false,
                btnText: "",
                pageUrl: "",
            });
            setImagePreviewUrl(null);
            setImageName(null);
            //    inputRef.current.value= null
            setIsEdit(false)
        };
    }, [event])

    return (
        <div className="py-2 px-2 sm:px-2 lg:px-2">
            <div>
                {/* Header */}
                <div className="flex justify-between items-center mb-2">
                    <h1 className="text-3xl font-bold text-gray-900">
                        {isEdit ? 'Edit Event' : 'Add Event'}
                    </h1>
                    {/* <div className="flex gap-4">
                    {!isEdit && <button
                        onClick={handleReset}
                        className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-700"
                    >
                        Reset Form
                    </button>}
                </div> */}
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="bg-white rounded-2xl">
                    {/* Image Preview */}
                    <div className="mb-8">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Class Image Preview
                        </label>
                        <div className="relative h-72 w-full bg-gray-100 rounded-lg overflow-hidden">
                            {imagePreviewUrl ? (
                                <img
                                    src={imagePreviewUrl}
                                    alt="Event preview"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="flex items-center justify-center h-full text-gray-400">
                                    No image preview available
                                </div>
                            )}

                            {imagePreviewUrl && <X className='absolute top-0 right-0 cursor-pointer' onClick={() => isEdit ? handleCancelDBImage(event) : handleCancelImage()} />}
                        </div>
                    </div>

                    {/* Basic Information */}
                    <div>
                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Event Title *
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={formData?.title}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter event title"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Image *
                            </label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                ref={inputRef}
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Price
                            </label>
                            <input
                                type="tel"
                                name="price"
                                value={formData.price}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter event Price"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Language
                            </label>
                            <input
                                type="text"
                                name="language"
                                value={formData.language}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter Language"
                            />
                        </div>
                    </div>

                    {/* Course Details */}
                    <div>
                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Date *
                            </label>
                            <input
                                type="text"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter date"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Time
                            </label>
                            <input
                                type="text"
                                name="time"
                                value={formData.time}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter time"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Page Url
                            </label>
                            <input
                                type="text"
                                name="pageUrl"
                                value={formData.pageUrl}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter page url"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Button Text *
                            </label>
                            <input
                                type="text"
                                name="btnText"
                                value={formData.btnText}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter button text"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Button Status *
                            </label>
                            <select
                                name="btnShow"
                                value={formData.btnShow}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="">Select Status</option>
                                <option value="show">Show</option>
                                <option value="hide">Hide</option>
                            </select>
                        </div>



                        {/* <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                           Booking Link *
                        </label>
                        <input
                            type="text"
                            name="bookingLink"
                            value={data.bookingLink}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter booking link"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Start Date
                        </label>
                        <input
                            type="date"
                            name="startDate"
                            value={data.startDate}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Start Date"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            End Date *
                        </label>
                        <input
                            type="date"
                            name="endDate"
                            value={data.endDate}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter total chapters"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Notes *
                        </label>
                        <input
                            type="text"
                            name="notes"
                            value={data.notes}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter  Some Note"
                        />
                    </div> */}

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Status *
                            </label>
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Disabled">Disabled</option>
                            </select>
                        </div>

                        {/* <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Delivery Method *
                        </label>
                        <select
                            name="deliveryMethod"
                            value={data.deliveryMethod}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Select Delivery Method</option>
                            <option value="Online">Online</option>
                            <option value="Live">Live</option>
                        </select>
                    </div> */}
                    </div>

                    {/* Description */}
                    {/* <div className="mb-8">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Class Description *
                    </label>
                    <textarea
                        name="description"
                        value={data.description}
                        onChange={handleInputChange}
                        required
                        rows="4"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter class description"
                    />
                </div> */}

                    {/* Form Actions */}
                    <div className="flex gap-4">
                        {isEdit ? <button
                            type="submit"
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                        >
                            {
                                loading.state && loading.name === "editevent" ?
                                    <BtnSpinner /> :
                                    <>
                                        <Save className="w-5 h-5" />
                                        <span className='text-white'>Update Event</span>
                                    </>
                            }

                        </button>
                            :
                            <button
                                type="submit"
                                className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                            >
                                {
                                    loading.state && loading.name === "addevent" ?
                                        <BtnSpinner /> :
                                        <>
                                            <Save className="w-5 h-5" />
                                            <span className='text-white'>Create Event</span>
                                        </>
                                }

                            </button>}
                        <button
                            type="button"
                            onClick={() => close()}
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
                        >
                            <X className="w-5 h-5" />
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddOrEditEvent